import React, { useMemo } from 'react';

import CssBaseline from '@mui/material/CssBaseline';
import {
  createTheme,
  ThemeProvider,
  responsiveFontSizes,
} from '@mui/material/styles';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
} from 'react-router-dom';

import Layout from './component/Layout';
import Credits from './component/Views/Credits';
import Intel from './component/Views/Intel';
import Formatter from './component/Views/KingdomNews';
import KingdomRoles from './component/Views/KingdomRoles';
import Login from './component/Views/Login';
import RecentIntel from './component/Views/RecentIntel';
import Simulation from './component/Views/Simulation';
import StatsWrapper from './component/Views/StatsWrapper';
import WarPlanner from './component/Views/WarPlanner';
import { useAppState } from './context/AppState';
import { isSignedIn } from './services/Auth';
//https://www.robinwieruch.de/react-router-private-routes/

const ProtectedRoute = ({ redirectPath = '/login', children }) => {
  if (!isSignedIn()) {
    return <Navigate to={redirectPath} replace />;
  }
  return children ? children : <Outlet />;
};

const App = () => {
  //const { appState } = useAppState();

  const theme = useMemo(() => {
    const palette2 = {
      // palette: {
      //   mode: appState.darkMode ? 'dark' : 'light',
      // },
      palette: {
        mode: 'dark',
      },
      typography: {
        h1: { fontSize: '3rem' },
        h2: { fontSize: '2rem' },
        h3: { fontSize: '1.5rem' },
        h4: { fontSize: '1.25rem' },
        h5: { fontSize: '1.125rem' },
        h6: { fontSize: '1rem' },
      },
    };
    let theme = createTheme(palette2);
    theme = responsiveFontSizes(theme);
    return theme;
  }, []);

  return (
    <div className='App'>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <Routes>
            <Route path='/' element={<Layout />}>
              <Route path='login' element={<Login />} />
              <Route element={<ProtectedRoute />}>
                <Route index element={<Intel />} />
                <Route path='enemy' element={<Intel />} />
                <Route path='stats' element={<StatsWrapper />} />
                <Route path='recent' element={<RecentIntel />} />
                <Route path='simulation' element={<Simulation />} />
                <Route path='opsplanner' element={<WarPlanner />} />
                <Route path='users' element={<KingdomRoles />} />
                <Route path='kingdomnews' element={<Formatter />} />
                <Route path='credits' element={<Credits />} />
              </Route>
              <Route path='*' element={<div>404</div>} />
              {/* Using path="*"" means "match anything", so this route
                acts like a catch-all for URLs that we don't have explicit
                routes for. */}
            </Route>
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </div>
  );
};

export default App;
